module.exports = __webpack_public_path__ + "static/q5answer3_hotdog_wishmas-01cb99f4ca4a72ff96d34d97b95be438.jpg";